












































































































































































































import ApprovalCard from '../../../modules/_components/ApprovalCard.vue';
import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import BaseCard from '../../_components/BaseCard.vue';
import CompanyUserService from '../../../services/company-user.service';
import SmsService from '../../../services/sms.service';
import {
  CompanyUserDto,
  CompanyUserUpdateDto,
  CompanyUserUpdateRefusalDto,
  CompanyUserUpdateRefusalReasonDto,
  AdminSendMessageDto,
} from '../../../dto';
import { BaseUser } from '../../../services/shared/auth';
import toast from '../../../../resources/assets/js/services/toast.js';
import {
  APPROVAL_STATUS,
  CONST_APPROVAL_STATUS,
  COMPANY_USER,
  CONST_COMPANY_USER,
} from '../../../services/shared';

import { getStatusColor } from '../../../core/utils/status-color.util';

@Component({
  name: 'CompanyUserDetail',
  components: {
    ApprovalCard,
    BaseCard,
  },
})
export default class CompanyUserDetail extends BaseComponent {
  private companyUserDto = new CompanyUserDto(BaseUser);
  private companyUserUpdateDto = new CompanyUserUpdateDto();
  private companyUserUpdateRefusalDto = new CompanyUserUpdateRefusalDto();
  private companyUserUpdateRefusalReasonDto = (this.companyUserUpdateRefusalDto.refusalReasons = new CompanyUserUpdateRefusalReasonDto());
  private companyUserAdminRole: COMPANY_USER[] = [...CONST_COMPANY_USER];
  private adminSendMessageDto = new AdminSendMessageDto();
  private deleteUserName = null;

  getStatusColor(status: APPROVAL_STATUS) {
    return getStatusColor(status);
  }

  findOne(id) {
    CompanyUserService.findOne(id).subscribe(res => {
      this.companyUserDto = res.data;
    });
  }

  showUpdateModal() {
    this.companyUserUpdateDto = this.companyUserDto;
    this.findOne(this.$route.params.id);
  }

  //사용자 정보 수정
  updateCompanyUser() {
    CompanyUserService.update(
      this.$route.params.id,
      this.companyUserUpdateDto,
    ).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  sendMessage() {
    this.adminSendMessageDto.phone = this.companyUserDto.phone;
    SmsService.sendMessage(this.adminSendMessageDto).subscribe(res => {
      if (res) {
        this.adminSendMessageDto = new AdminSendMessageDto();
        toast.success('문자가 발송 되었습니다.');
      } else {
        return;
      }
    });
  }

  // 삭제
  deleteCompanyUser() {
    if (this.deleteUserName === this.companyUserDto.name) {
      CompanyUserService.deleteCompanyUser(this.$route.params.id).subscribe(
        res => {
          if (res) {
            this.$router.push('/company/company-user');
            toast.success('삭제완료');
          }
        },
      );
    } else {
      toast.error('이름을 정확히 입력해주세요');
    }
  }

  // 승인
  updateApproval() {
    CompanyUserService.updateCompanyUserStatus(
      this.$route.params.id,
      'approve-update',
    ).subscribe(res => {
      if (res) {
        this.findOne(this.$route.params.id);
        toast.success('승인완료');
      }
    });
  }

  // 거절
  updateRefusal() {
    CompanyUserService.updateCompanyUserStatus(
      this.$route.params.id,
      'refuse-update',
      this.companyUserUpdateRefusalDto,
    ).subscribe(res => {
      if (res) {
        this.findOne(this.$route.params.id);
        toast.success('승인거절');
      }
    });
  }

  created() {
    const id = this.$route.params.id;
    this.findOne(id);
  }
}
